export class NewContact {
    constructor(
        public equityCapitalFrom: number,
        public equityCapitalTo: number,
        public monthlyInvestFrom: number,
        public monthlyInvestTo: number,
        public yourName: string,
        public yourMail: string,
        public yourMobile: string,
        public newsletterConsent: boolean,
        public source?: string,
        public selectedPath?: string,
        public bundesland?: string,
        public iidConsent?: boolean,
    ) {}
}
